import { Icon, PlusMinus } from '@tallink/components-lib'
import classNames from 'classnames'
import React from 'react'

import useFormatPrice from '../../../utils/formatPrice'
import MorePropTypes from '../../../utils/MorePropTypes'
import { isGiftCardType } from '../../../utils/serialTickets'
import Hint from '../Hint/Hint'
import s from './DesktopSerialTicket.module.scss'

export default function DesktopSerialTicket({ ticket, plusMinusProps }) {
  const formatPrice = useFormatPrice()
  const { code, price, type, title, tooltipTitle, tooltipInfo } = ticket
  const iconProps = getIconProps({ type, code })

  return (
    <div id={code}>
      <div className={s.cell}>
        <div className={s['round-icon']}>{iconProps && <Icon {...iconProps} />}</div>
      </div>
      <div className={classNames(s.cell, s['text-and-price'])}>
        <div className={s.text}>
          <span className={s.title} dangerouslySetInnerHTML={{ __html: title }} />
          {(tooltipTitle || tooltipInfo) && <Hint text={tooltipInfo} title={tooltipTitle} />}
        </div>
        <div className={s.price}>{formatPrice(price)}</div>
      </div>
      <div className={classNames(s.cell, s.amount)}>
        <PlusMinus {...plusMinusProps} />
      </div>
    </div>
  )
}

DesktopSerialTicket.propTypes = {
  plusMinusProps: MorePropTypes.plusMinusDesktopProps.isRequired,
  ticket: MorePropTypes.serialTicket.isRequired
}

export function getIconProps({ type, code }) {
  if (type === 'PASSENGER' || isGiftCardType(type)) return { type: 'adult', size: 'l' }
  if (type === 'VEHICLE') {
    const vehicleType = code?.startsWith('SERIAL V') ? 'vehicle-van' : 'vehicle-car'

    return { type: vehicleType, size: 'xl' }
  }
  return null
}
